<template>
  <div id="choose-apply-invoice-info">
    <div class="head clearfix">
      <span class="c-6 f-14">开票信息</span>
      <span class="c-hover f-13 fr pointer" @click="editInvoiceInfo">编辑开票信息</span>
    </div>
    <div class="content">
      <el-row>
        <el-col :span="8"
          ><div class="form-item">抬头：{{ info.invoiceOrgName }}</div></el-col
        >
        <el-col :span="8"
          ><div class="form-item">银行账号：{{ info.invoiceAccount }}</div></el-col
        >
        <el-col :span="8"
          ><div class="form-item">开票地址：{{ info.invoiceAddress }}</div></el-col
        >
      </el-row>
      <el-row>
        <el-col :span="8"
          ><div class="form-item">纳税号：{{ info.taxNumber }}</div></el-col
        >
        <el-col :span="8"
          ><div class="form-item">开户银行：{{ info.bankOfDeposit }}</div></el-col
        >
        <el-col :span="8"
          ><div class="form-item">开票电话：{{ info.phoneNumber }}</div></el-col
        >
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="form-item">
            发票类型：
            <el-select v-model="info.invoiceType" size="mini" style="width: 150px">
              <el-option label="增值税专用发票" :value="1"></el-option>
              <el-option label="增值税普通发票" :value="2"></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="8"
          ><div class="form-item">发票单位：{{ info.invoiceUnit === 1 ? '吨' : '' }}</div></el-col
        >
      </el-row>
      <el-row>
        <el-col :span="16">
          <div class="form-item">
            发票备注：
            <el-input
              v-model="info.invoiceRemark"
              size="mini"
              placeholder="请输入发票备注"
              maxlength="50"
              style="width: 400px"
            ></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="form-item">
            开票说明：
            <el-input
              v-model="info.invoiceDesc"
              size="mini"
              placeholder="请输入开票说明"
              maxlength="200"
              style="width: 600px"
            ></el-input>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="480px"
      title="开票信息"
    >
      <el-form :model="infoForm" inline label-width="80px" style="width:420px;margin:0 auto;">
        <el-form-item label="收件人">{{ infoForm.invoiceOrgName }}</el-form-item>
        <el-form-item required label="纳税号">
          <el-input
            style="width:300px"
            maxlength="80"
            v-model.trim="infoForm.taxNumber"
            placeholder="请输入纳税号"
          ></el-input>
        </el-form-item>
        <el-form-item required label="银行账号">
          <el-input
            style="width:300px"
            maxlength="80"
            v-model.trim="infoForm.invoiceAccount"
            placeholder="请输入银行账号"
          ></el-input>
        </el-form-item>
        <el-form-item required label="开票地址">
          <el-input
            style="width:300px"
            maxlength="80"
            v-model.trim="infoForm.invoiceAddress"
            placeholder="请输入开票地址"
          ></el-input>
        </el-form-item>
        <el-form-item required label="开户银行">
          <el-input
            style="width:300px"
            maxlength="80"
            v-model.trim="infoForm.bankOfDeposit"
            placeholder="请输入开户银行"
          ></el-input>
        </el-form-item>
        <el-form-item required label="开票电话">
          <el-input
            style="width:300px"
            :value="infoForm.phoneNumber"
            @input="handleInputPhone"
            maxlength="11"
            placeholder="请输入开票电话"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveInfo">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ApplyInvoiceInfo',
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      infoForm: {
        invoiceOrgName: '',
        taxNumber: '',
        invoiceAccount: '',
        invoiceAddress: '',
        bankOfDeposit: '',
        phoneNumber: ''
      }
    }
  },
  methods: {
    editInvoiceInfo() {
      Object.keys(this.infoForm).forEach(key => {
        this.infoForm[key] = this.info[key]
      })
      this.dialogVisible = true
    },
    handleInputPhone(val) {
      if (val) {
        const match = val.match(/^\d+$/)
        if (match) {
          this.infoForm.phoneNumber = match[0]
        }
      } else {
        this.infoForm.phoneNumber = ''
      }
    },
    saveInfo() {
      const {
        taxNumber,
        invoiceAccount,
        invoiceAddress,
        bankOfDeposit,
        phoneNumber
      } = this.infoForm
      if (!taxNumber || !invoiceAccount || !invoiceAddress || !bankOfDeposit || !phoneNumber) {
        this.$message.error('请输入完整的开票信息')
        return
      }
      this.$emit('update-info', this.infoForm)
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="less">
#choose-apply-invoice-info {
  .el-dialog__body {
    padding-bottom: 0;
  }
}
</style>

<style lang="less" scoped>
#choose-apply-invoice-info {
  .head {
    width: 100%;
    margin-top: 20px;
    height: 44px;
    line-height: 44px;
  }
  .content {
    box-sizing: border-box;
    width: 100%;
    padding-bottom: 20px;
    border: 2px solid #f8f8f8;
  }
  .form-item {
    padding: 20px 30px 0 30px;
    line-height: 20px;
    font-size: 13px;
    color: #666;
  }
}
</style>
